module.exports = __webpack_public_path__ + "static/printing-37b68aa2f3c03340d500a1d028cfbec9.jpg";